import Vue from "vue";

const state = () => ({
  cdPessoa: "",
  numeroProjeto: "",
  selecaoSafra: null,
  selecaoProjeto: null,
  selecaoCooperado: null,
  selecaoMunicipio: null,
  selecaoTipoProjeto: null,
  selecaoClienteRural: null,
  selecaoLinhaCredito: null,
  selecaoStatusProjeto: null,
  selecaoItemAgropecuario: null,
  selecaoModalidadeSeguro: null,
  selecaoInstituicaoFinanceira: null
});

const mutations = {
  SET_FILTRO_PROJETOS(state, filtro) {
    Object.keys(filtro).forEach(key => {
      if (key in state) {
        Vue.set(state, key, filtro[key]);
      }
    });
  },

  SET_FILTRO_CAMPO(state, { campo, valor }) {
    if (campo in state) {
      Vue.set(state, campo, valor);
    }
  },

  SET_PAGINATION(state, pagination) {
    Vue.set(state, "pagination", {
      ...state.pagination,
      ...pagination
    });
  },

  RESET_FILTROS_PROJETOS(state) {
    const campos = [
      "selecaoSafra",
      "numeroProjeto",
      "selecaoProjeto",
      "selecaoCooperado",
      "selecaoMunicipio",
      "selecaoTipoProjeto",
      "selecaoClienteRural",
      "selecaoLinhaCredito",
      "selecaoStatusProjeto",
      "selecaoItemAgropecuario",
      "selecaoModalidadeSeguro",
      "selecaoInstituicaoFinanceira"
    ];

    campos.forEach(key => {
      Vue.set(state, key, key === "numeroProjeto" ? "" : null);
    });
  }
};

const getters = {
  filtroProjetos: state => state,

  hasFiltrosAtivos: state => {
    const campos = [
      "selecaoSafra",
      "numeroProjeto",
      "selecaoProjeto",
      "selecaoMunicipio",
      "selecaoCooperado",
      "selecaoTipoProjeto",
      "selecaoClienteRural",
      "selecaoLinhaCredito",
      "selecaoStatusProjeto",
      "selecaoItemAgropecuario",
      "selecaoModalidadeSeguro",
      "selecaoInstituicaoFinanceira"
    ];

    return campos.some(campo => {
      const value = state[campo];
      return value !== null && value !== undefined && value !== "";
    });
  }
};

const actions = {
  setFiltroProjetos({ commit }, filtro) {
    commit("SET_FILTRO_PROJETOS", filtro);
  },

  setFiltroCampo({ commit }, payload) {
    commit("SET_FILTRO_CAMPO", payload);
  },

  limparFiltrosProjetos({ commit }) {
    commit("RESET_FILTROS_PROJETOS");
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
